<template>
  <div>
    <content-view>
      <div class="ware-house">
        <p class="ware-house_title">
          <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>
          当前仓库：{{name}}
        </p>
        <a-table
          bordered
          :dataSource="tradeDetail"
          :columns="columns"
          :pagination="pagination"
          :rowKey="record => record.id"
        ></a-table>
      </div>
    </content-view>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'wareHouse',
  components: {},
  props: {},
  data() {
    const columns = [
      {
        title: '商品编号',
        dataIndex: 'serialNum',
        scopedSlots: {
          customRender: 'serialNum'
        }
      },
      {
        title: '商品名称',
        dataIndex: 'goodsName'
      },
      {
        title: '商品类型',
        dataIndex: 'goodsType'
      },
      {
        title: '商品规格',
        dataIndex: 'goodsSize'
      },
      {
        title: '单位',
        dataIndex: 'goodsUnit'
      },
      {
        title: '当前库存量',
        dataIndex: 'currentInventory'
      },
      {
        title: '总入库量',
        dataIndex: 'totalInventory'
      }
    ];
    return {
      name: this.$route.query.name,
      columns,
      tradeDetail: [],
      pagination: {
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        current: 1,
        pageSize: 20
      }
    };
  },
  computed: {},
  methods: {
    warehouseList() {
      this.$api.storage
        .tradeDetail({
          params: { uid: this.$route.query.id }
        })
        .then(res => {
          this.tradeDetail = res.data;
          this.pagination.total = res.total;
        });
    }
  },
  created() {},
  mounted() {
    this.warehouseList();
  }
};
</script>
<style lang="scss">
.ware-house {
  background-color: #fff;
  padding: 24px 32px;
  border-radius: 2px;
  min-height: 496px;
  &_title {
    width: 100%;
    height: 40px;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    padding-left: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .ant-table-pagination {
    display: none;
  }
}
</style>